// Datalayer.ts
import { fetchData } from 'Helpers/ApiUtils';

export default class Datalayer {
  static push(dates) {
    window.dataLayer = window.dataLayer || [];

    if (Array.isArray(dates)) {
      for (const data of dates) {
        if (data && data.event) {
          window.dataLayer.push(data);
        }
      }
    } else {
      console.error('Invalid data format. Expected an array.');
    }
  }
  static async storeDatalayerEvent(title: string, position: string) {
    const data = {
      sessionType: 'datalayerEvent',
      sessionData: {
        title,
        position,
        event: 'select_content',
      },
    };
    await fetchData('/sessionHandle', 'POST', data);
  }

  static async clickEventPush(title: string, position: string) {

    await this.storeDatalayerEvent(title, position);

    const responseData = await fetchData('/getStoreClickEvent', 'GET');

    if (responseData) {
      await this.push(responseData);
    }
  }
}
